const init = () => {

	const activeClass = 'animating';
	const obsConfig   = {
		attributes: true
	};

	let intervalHandle = null;

	const handleMutation = (mutationsList) => {
		const el       = mutationsList[0].target;
		const imgs     = el.getElementsByTagName('img');
		const imgCount = imgs.length;

		if (el.classList.contains(activeClass)) {
			
			let i = 0;
			intervalHandle = setInterval(() => {
				imgs[i % imgCount].style.zIndex   = 1;
				imgs[++i % imgCount].style.zIndex = 2;
			}, 500);
		}
		else {
			// Clear loop
			if (intervalHandle !== null) {
				clearInterval(intervalHandle);
			}

			// Set back to original state
			for (const img of imgs) {
				img.style.zIndex = 1;
			}
			imgs.item(0).style.zIndex = 2;

			intervalHandle = null;
		}
	}

	const obs = new MutationObserver(handleMutation);

	for (const f of document.querySelectorAll('[data-img-animate]')) {

		obs.observe(f, obsConfig);

		f.addEventListener('mouseenter', (e) => {
			e.target.classList.add(activeClass);

			// const el   = e.target;
			// const imgs = el.getElementsByTagName('img');
			// console.log(imgs);

			// for (const img of imgs) {
			// 	// console.log(img);
			// }
		});
		f.addEventListener('mouseleave', (e) => {
			e.target.classList.remove(activeClass);
		});
	}
}

export default init